export class DateUtil {
  public static readonly dateFormat = 'yyyy/MM/dd';
  public static readonly dateTimeFormat = 'yyyy/MM/dd HH:mm';
  public static readonly dateTimeFormatForReport = 'yyyyMMdd_HHmm';
  public static readonly dateFormatWithoutSlashes = 'yyyyMMdd';
  public static readonly dateFormatWithHyphenated = 'yyyy-MM-dd';
}

export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'YYYY/MM/DD'
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
  }
};

export function areDatesEqualIgnoringTime(date1: Date, date2: Date) {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate();
}

export function addDaysToDate(inputDate: Date, numberOfDays: number) {
  let resultDate = new Date(inputDate);
  resultDate.setDate(resultDate.getDate() + numberOfDays);
  return resultDate;
}

export function convertToUTC(dateString: string): Date {
  const date = new Date(dateString);
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
}